module.exports = __webpack_public_path__ + "img/steps_1.9cd7a53c.png";